import { Suspense, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { GoogleAnalytics } from './components/GoogleAnalytics';
import { ProtectedRoute } from './components/ProtectedRoute';
import { routes } from './routes';
import { NEXT_PUBLIC_GA_MEASUREMENT_ID } from '@/lib/env';

function App() {
  // Fonts are loaded via Google Fonts link in index.html
  // CSS variables are defined in app/globals.css
  // Tailwind config uses these variables for font-family
  // No need to apply classes manually - CSS handles it

  return (
    <>
      {/* Google Analytics */}
      {NEXT_PUBLIC_GA_MEASUREMENT_ID && <GoogleAnalytics />}
      <ProtectedRoute>
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
          <Routes>
            {routes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={
                  route.protected ? (
                    <ProtectedRoute>
                      <route.component />
                    </ProtectedRoute>
                  ) : (
                    <route.component />
                  )
                }
              />
            ))}
          </Routes>
        </Suspense>
      </ProtectedRoute>
      <Toaster />
    </>
  );
}

export default App;
